import * as React from 'react';

const ComponentProvider: React.FC<{ componentPath: string, data?: any }> = ({ componentPath, data }) => {
    const Component = React.lazy(() => import('../modules' + componentPath));
    return <React.Suspense fallback={<div></div>}>
        <Component {...(data ?? {})}></Component>
    </React.Suspense>
};

export default ComponentProvider;